import clsx from "clsx";
import { Block } from "../Block/Block";
import { UIButton } from "../UIButton/UIButton";
import s from "./style.module.scss";
import { useNavigate } from "react-router";
import { userAtom } from "@/core/reatom/state/user/user";
import { useAction, useAtom } from "@reatom/npm-react";
import { toggleModal } from "@/core/reatom/state/modal/modal";

interface ServiceEpic {
  createOrder: () => void;
}

export const ServiceEpic = (props: ServiceEpic) => {
  const { createOrder } = props;
  const [user] = useAtom(userAtom);
  const handleToggleModal = useAction(toggleModal);

  const navigate = useNavigate();
  return (
    <>
      <div className={s.fakeEpic} />
      <Block borderRadius="top" className={s.wrapper}>
        <UIButton
          fontType={"primary-2"}
          className={s.button}
          onClick={() => {
            if (user === 1) {
              createOrder();
            } else {
              handleToggleModal("auth");
            }
          }}
        >
          Купить
        </UIButton>
        <UIButton
          fontType={"primary-2"}
          color="inverted"
          className={clsx(s.button, s.back)}
          onClick={() => navigate("/")}
        >
          Вернуться назад
        </UIButton>
      </Block>
    </>
  );
};
